import React, { useContext, FC, RefAttributes, forwardRef } from 'react';
import { MenuToggleProps } from './SideNavTypes';
import { NavContext } from './NavContext';
import { Element } from './NavElement';
import { get } from 'lodash';

export const MenuToggle: FC<MenuToggleProps & RefAttributes<HTMLButtonElement>> = forwardRef(
  ({ toggleClose, toggleOpen, ariaControls }, ref) => {
    const context = useContext(NavContext);
    const toggle = context.mobileToggle ? toggleClose : toggleOpen;
    return (
      <button
        aria-controls={ariaControls}
        aria-expanded={context.mobileToggle}
        aria-haspopup="true"
        className="mobile-item order-2"
        aria-label={get(toggle, 'ariaLabel')}
        onClick={e => {
          e.preventDefault();
          if (!context.clickedOutside) {
            context.setMobileToggle(!context.mobileToggle);
          }
        }}
        role="menuitem"
        ref={ref}
        title={get(toggle, 'navId')}
        id={get(toggle, 'navId')}>
        <Element label={get(toggle, 'label')} src={get(toggle, 'invertedLogo')} />
      </button>
    );
  }
);

MenuToggle.displayName = 'MenuToggle';
export default MenuToggle;
